import { useQuery } from '@tanstack/react-query'
import { SHOP_QUERY_KEYS } from '@/modules/shop/constants'
import { ShopPurchasesService } from '../services/ShopPurchasesService'

interface UseQueryGetPurchaseByIdProps {
	id: string
	enabled?: boolean
}

export default function useQueryGetPurchaseById({
	id,
	enabled = true,
}: UseQueryGetPurchaseByIdProps) {
	return useQuery({
		queryKey: SHOP_QUERY_KEYS.PURCHASES.DETAIL(id),
		queryFn: () => ShopPurchasesService.getPurchaseById(id),
		enabled: enabled && !!id,
	})
}
